import React, { CSSProperties, FC } from 'react';
import { useDrop } from 'react-dnd';
import plusLogo from '../plus.svg';
import { DndTypes } from './DndTypes.js';

interface Props {
  droppableId: string;
}

function selectBackgroundColor(isActive: boolean, canDrop: boolean) {
  if (isActive) {
    return 'rgba(0,0,0,0.1)';
  } else if (canDrop) {
    return '';
  } else {
    return '';
  }
}

const DroppableComponent: FC<Props> = (props) => {
  const { droppableId } = props;
  const [{ canDrop, isOver }, drop] = useDrop(
    () => ({
      accept: DndTypes.BOX,
      drop: (_item, monitor) => {
        const didDrop = monitor.didDrop();
        if (didDrop) {
          return;
        }

        return {
          droppableId,
          allowedDropEffect: droppableId,
        };
      },
      collect: (monitor: any) => ({
        isOver: monitor.isOver(),
        canDrop: monitor.canDrop(),
      }),
    }),
    [droppableId],
  );

  const isActive = canDrop && isOver;
  const backgroundColor = selectBackgroundColor(isActive, canDrop);
  return (
    <div
      className={'h-full flex justify-center items-center border border-dashed border-black text-6xl z-50 px-4'}
      ref={drop}
      style={{ backgroundColor }}
    >
      <img src={plusLogo} alt="plus" className={'w-10 h-10'} />
    </div>
  );
};

export default DroppableComponent;
